function Navigation(){

    console.log("navigation");

    var self = this;

    //self.transitionSpeed = 0.25;

   // self.initialLoad= true;
    self.$contentWrapper = $("#content-wrapper");
    self.ajaxLoader = new AjaxLoader(self);

    /*self.contentArray = [];
    self.previousPage = 0;
    self.currentPage = 0;

    self.url = window.location.href;

    self.$pageWrapper = $(".page-wrapper");
    self.$menuContainer = $("#menu-container");
    self.$menuBtn = $(".menu-btn");
    self.$menu = $(".menu");
    self.$contentWrapper = $("#content-wrapper");
    self.$innerContent = $(".inner-content");
    self.$content = $('#content');

    self.next = ".next";
    self.prev = ".prev";


    self.url = "http://" +document.domain;

    self.menu = new Menu(self.$menuContainer, self.$menuBtn, self.$menu, self);
    self.ajaxLoader = new AjaxLoader(self.url, self.$contentWrapper, self);
    //self.ajaxLoader = new AjaxLoader("http://ngen.wpengine.com", self.$contentWrapper, self);

    if (self.currentPage ===0){


    } else {

        Draggable.create("#scroller", {type: "scrollTop", edgeResistance: 0.5, throwProps: true, lockAxis: true});

    }
    self.next = new NavigationNextBtn(self.next, self);
    self.prev = new NavigationPrevBtn(self.prev, self);

    self.homeAnim = new PageAnimHome(self.$contentWrapper, self);
    self.contentAnim = new PageAnimContent(self.$contentWrapper, self);
    self.headerAnim = new PageAnimHeader(self);

    self.loadFirstSlide();*/


    $(".nav a").click(function(e) {

        e.preventDefault();

        console.log("click");

        var href = $(this).attr('href');

        console.log("href = " , href);

        self.ajaxLoader.load(href);


    });

}
/*
Navigation.prototype.loadFirstSlide = function (){

    var self = this;

    self.contentURL = document.URL;

    for (var i=0; i < self.contentArray.length; i++){

        if (self.contentArray[i].link === self.contentURL ){

            self.currentPage = i;

        }

    }

    self.setPrevNextPages();

    self.loadContent();

};

Navigation.prototype.loadSlide = function (index){

    var self = this;

    self.previousPage = self.currentPage;

    self.currentPage = index;

    self.contentURL = self.contentArray[self.currentPage].link;

    self.setPrevNextPages();

    self.loadContent();

};

Navigation.prototype.nextSlide = function (){

    var self = this;

    self.previousPage = self.currentPage;

    self.currentPage ++;

    if (self.currentPage === self.contentArray.length){

        self.currentPage =0;

    }

    self.contentURL = self.contentArray[self.currentPage].link;

    self.setPrevNextPages();

    self.loadContent();

};
Navigation.prototype.prevSlide = function (){

    var self = this;

    self.previousPage = self.currentPage;

    self.currentPage --;

    if (self.currentPage < 0 ){

        self.currentPage =self.contentArray.length-1;

    }

    self.contentURL = self.contentArray[self.currentPage].link;

    self.setPrevNextPages();

    self.loadContent();

};

Navigation.prototype.loadContent = function (){

    var self = this;

    self.hideContent();


};

Navigation.prototype.loadFinished = function () {

    var self = this;

    console.log("loadFinished");

    self.showContent();

    self.setNavigationTitles();

    self.menu.menuNavSetActiveLink(self.currentPage);


};

Navigation.prototype.setPrevNextPages = function (){

    var self = this;

    self.nextPage = self.currentPage + 1;
    self.prevPage = self.currentPage - 1;



    if (self.nextPage > self.contentArray.length-1){
        self.nextPage =0;
    }

    if (self.prevPage < 0){
        self.prevPage = self.contentArray.length-1;
    }

    console.log("nextPage = "+ self.nextPage + " prevPage =  " + self.prevPage);

};


Navigation.prototype.setNavigationTitles = function (){

    var self = this;

    self.nextTitle = self.contentArray[self.nextPage].title;
    self.prevTitle = self.contentArray[self.prevPage].title;

    self.next.setTitle(self.nextTitle);
    self.prev.setTitle(self.prevTitle);



};
Navigation.prototype.hideContent = function (){

    var self = this;

    if (self.previousPage === 0){

        self.homeAnim.stopAnim();

    }

    //console.log("self.prevPage " + self.prevPage);
    //console.log("self.currentPage " + self.currentPage);

    function hideComplete(){

        self.ajaxLoader.load(self.contentURL);
    }

    TweenMax.to(self.$contentWrapper, 0.25, {autoAlpha:0, onComplete:hideComplete});

    if (Draggable.get("#scroller")){

        Draggable.get("#scroller").kill();

    }


};
Navigation.prototype.showContent = function (){

    var self = this;

    if (self.initialLoad ===true){

        self.initialLoad =false;

        self.headerAnim.setContent();

        TweenMax.set( self.$pageWrapper, {autoAlpha: 1});

        self.headerAnim.animateContent();

        self.showPageContent();

    } else {

        self.showPageContent();
    }

};

Navigation.prototype.showPageContent = function (){

    var self = this;

    if (self.currentPage === 0) {

        self.homeAnim.setContent();

        self.homeAnim.animateContent();

    } else {

        self.contentAnim.setContent();

        self.contentAnim.animateContent();

    }

};*/


